export default "__VITE_ASSET__XhPG8dLQ__"